module.exports = __webpack_public_path__ + "media/images/brand/logo-03-e96049babb13bb52de0e3492250f308c.png";